import { render, staticRenderFns } from "./TagSelectBox.vue?vue&type=template&id=f1104828&scoped=true"
import script from "./TagSelectBox.vue?vue&type=script&lang=js"
export * from "./TagSelectBox.vue?vue&type=script&lang=js"
import style0 from "./TagSelectBox.vue?vue&type=style&index=0&id=f1104828&lang=less&scoped=true"
import style1 from "./TagSelectBox.vue?vue&type=style&index=1&id=f1104828&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1104828",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1104828')) {
      api.createRecord('f1104828', component.options)
    } else {
      api.reload('f1104828', component.options)
    }
    module.hot.accept("./TagSelectBox.vue?vue&type=template&id=f1104828&scoped=true", function () {
      api.rerender('f1104828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/TagSelectBox.vue"
export default component.exports